"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSupportedLanguages = exports.getHomepageContext = exports.getBrandWorkflows = void 0;
/**
 * Makes a GET request to the given API (URL), handling errors and type conversion (wrapper around the browser's fetch).
 */
const fetchFromServer = async (url) => {
    const response = await fetch(url)
        .catch((error) => {
        throw new Error(`[BCS Client] fetchFromServer() -> An error occurred while fetching from ${url}: ${error}`);
    });
    if (!response.ok) {
        const partialResponse = (await response.text()).slice(0, 2047);
        throw new Error(`[BCS Client] fetchFromServer() -> The fetch to ${url} returned ${response.status} ` +
            `(First 2048 response characters: '${partialResponse}')`);
    }
    const body = await response.text();
    let result;
    try {
        result = JSON.parse(body);
    }
    catch (error) {
        const partialResponse = body.slice(0, 2047);
        throw new Error(`[BCS Client] fetchFromServer() -> Failed to parse response JSON for the fetch to ${url}: ${error} ` +
            `(First 2048 response characters: '${partialResponse}')`);
    }
    return result;
};
/**
 * Attempts to fetch the result (Promise) for the given API (URL) from the result store, calling the supplied fetcher
 * if the store or store result doesn't exist. If the fetcher is invoked, the result is added to the store.
 */
const fetchResult = (url, fetcher) => {
    const resultStore = (window.__BRAND_REGISTRY_API_RESULTS__ ?? {});
    const existingResult = resultStore[url];
    if (existingResult instanceof Promise) {
        return existingResult;
    }
    const result = fetcher(url);
    resultStore[url] = result;
    window.__BRAND_REGISTRY_API_RESULTS__ = resultStore;
    return result;
};
/**
 * Fetches brand workflow data for the logged-in/spoofed customer
 */
const getBrandWorkflows = () => fetchResult('/home/api/brand-workflows', (url) => fetchFromServer(url));
exports.getBrandWorkflows = getBrandWorkflows;
/**
 * Fetches the Homepage context for the logged-in/spoofed customer.
 */
const getHomepageContext = () => fetchResult('/home/api/context', async (url) => {
    const serverContext = await fetchFromServer(url);
    // Add a list of brand IDs to the context object for convenience
    const brandIds = Object.keys(serverContext?.brands ?? {}).map(n => Number.parseInt(n));
    return { brandIds, ...serverContext };
});
exports.getHomepageContext = getHomepageContext;
/**
 * Fetches the supported languages for the logged-in (dummy) merchant's marketplace.
 */
const getSupportedLanguages = () => fetchResult('/home/api/supported-languages', (url) => fetchFromServer(url));
exports.getSupportedLanguages = getSupportedLanguages;
